<template>
  <div
    :class="['card mb-2 ai-builder-card', { 'ai-builder-deleted': item.deleted }]"
  >
    <div class="card-body py-2">
      <div class="d-flex justify-content-between align-items-start">
        <div>
          <button
            v-if="collapsible"
            type="button"
            class="btn btn-sm ai-builder-btn-collapse mr-1"
            :aria-expanded="String(!collapsed)"
            :title="
              collapsed
                ? $t('reusable.aiBuilderItemCard.expand')
                : $t('reusable.aiBuilderItemCard.collapse')
            "
            @click="$emit('toggle-collapse')"
          >
            <span aria-hidden="true">{{ collapsed ? "▸" : "▾" }}</span>
          </button>
          <slot name="header"></slot>
          <span v-if="item.existing" class="badge badge-secondary ml-1">
            {{ $t("reusable.aiBuilderItemCard.alreadyExists") }}
          </span>
        </div>
        <div class="text-nowrap ml-2">
          <button
            v-if="!item.deleted"
            type="button"
            class="btn btn-sm ai-builder-btn ai-builder-btn-remove"
            :disabled="busy"
            @click="$emit('remove')"
          >
            <span aria-hidden="true" class="mr-1">&times;</span
            >{{ $t("reusable.aiBuilderItemCard.remove") }}
          </button>
          <button
            v-else
            type="button"
            class="btn btn-sm ai-builder-btn ai-builder-btn-restore"
            :disabled="busy"
            @click="$emit('restore')"
          >
            <span aria-hidden="true" class="mr-1">&#8634;</span
            >{{ $t("reusable.aiBuilderItemCard.restore") }}
          </button>
        </div>
      </div>

      <div v-if="item.regenerating" class="text-muted small my-2">
        <div class="spinner-border spinner-border-sm mr-1" role="status"></div>
        {{ $t("reusable.aiBuilderItemCard.generating") }}
      </div>
      <template v-else-if="!collapsed">
        <slot name="body"></slot>
      </template>

      <AiThemeInput
        v-if="!item.deleted && !collapsed"
        v-model="item.theme"
        class="mt-1"
        :placeholder="$t('reusable.aiBuilderItemCard.themePlaceholder')"
        :hint="$t('reusable.aiBuilderItemCard.themeHint')"
        :info="theme_info || $t('reusable.aiBuilderItemCard.themeInfo')"
      >
        <template #append>
          <button
            type="button"
            class="btn ai-builder-btn-regen"
            :disabled="busy"
            @click="$emit('regenerate')"
          >
            <span aria-hidden="true" class="mr-1">&#8635;</span
            >{{ $t("reusable.aiBuilderItemCard.regenerate") }}
          </button>
        </template>
      </AiThemeInput>
    </div>
  </div>
</template>

<script>
import AiThemeInput from "./AiThemeInput";

// Card compartida por los modales de "creación rápida con IA": muestra un
// ítem propuesto/existente con las acciones Quitar/Restaurar y
// Regenerar-con-tema. El contenido variable va en los slots "header" y
// "body"; el estado vive en `item` (deleted/existing/regenerating/theme) y
// las acciones se delegan al padre vía eventos.
export default {
  name: "AiBuilderItemCard",
  components: { AiThemeInput },
  props: {
    item: {
      type: Object,
      required: true,
    },
    busy: {
      type: Boolean,
      default: false,
    },
    // Ayuda con ejemplos específica del dominio; si no se entrega se usa
    // la genérica de la card.
    theme_info: {
      type: String,
      default: "",
    },
    // Colapso para builders con estructura de árbol: muestra el botón ▸/▾ y,
    // colapsada, la card queda reducida a su encabezado (el padre decide qué
    // hacer con los hijos vía el evento "toggle-collapse").
    collapsible: {
      type: Boolean,
      default: false,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped src="./ai-builder.css"></style>
